"use strict";
// Based upon TMP's `teams-stardust-ui`
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkV2ThemeOverrides = exports.defaultV2ThemeOverrides = exports.highContrastThemeOverrides = exports.TeamsTheme = void 0;
var constants_1 = require("./constants");
Object.defineProperty(exports, "TeamsTheme", { enumerable: true, get: function () { return constants_1.TeamsTheme; } });
// Teams high contrast theme overrides
var theme_1 = require("./teams-high-contrast/theme");
Object.defineProperty(exports, "highContrastThemeOverrides", { enumerable: true, get: function () { return theme_1.highContrastThemeOverrides; } });
// Teams defaultV2 theme overrides
var theme_2 = require("./teams-v2/theme");
Object.defineProperty(exports, "defaultV2ThemeOverrides", { enumerable: true, get: function () { return theme_2.defaultV2ThemeOverrides; } });
// Teams darkV2 theme overrides
var theme_3 = require("./teams-dark-v2/theme");
Object.defineProperty(exports, "darkV2ThemeOverrides", { enumerable: true, get: function () { return theme_3.darkV2ThemeOverrides; } });
//# sourceMappingURL=index.js.map